import { useMutation, useQueryClient } from '@tanstack/react-query';

import createSamplingIntent from '../api/createSamplingIntent';

export const useSamplingIntent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ body, productId }: any) => {
      return await createSamplingIntent(productId, body);
    },
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['product-quotes', variables.productId]
      });
    }
  });
};
